import L from 'leaflet'
import { Marker, Tooltip } from 'react-leaflet'
import { CustomToolTip } from './CustomToolTip'
import './customMarker.scss'
import { useEffect, useState } from 'react'
import { LandingPageProjectInfo } from '@models/projects.model'

interface CustomMarkerProps {
	markerElem: LandingPageProjectInfo
	children?: JSX.Element | string
	mapRef: any
	projectId?: string
}

interface Position {
	lat: number
	lng: number
}

export const CustomMarker = ({ markerElem, children, mapRef, projectId }: CustomMarkerProps) => {
	const position: Position = { lat: markerElem['y_coord'], lng: markerElem['x_coord'] }
	const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
	// const open = Boolean(anchorEl)
	const [open, setOpen] = useState(false)

	const icon = () => {
		return new L.DivIcon({
			iconSize: [40, 40],
			html: `
            <div class="custom-marker-wrapper">
            <div class="custom-marker-dot">
                <div class="custom-marker-ring1">
                  <div class="custom-marker-ring2"></div>
                </div>
            </div>
            </div>
            `,
		})
	}

	const handleClick = () => {
		const tooptipNode = document.getElementById(`tooltip-${projectId}`)?.parentNode
		mapRef.current.setView([markerElem['y_coord'], markerElem['x_coord']])
		setTimeout(() => {
			if (tooptipNode) {
				setAnchorEl(tooptipNode as any)
				setOpen(true)
			}
		}, 200)
	}

	const handleClose = () => {
		setAnchorEl(null)
		setOpen(false)
	}

	return (
		<>
			<Marker
				eventHandlers={{
					click: () => {
						handleClick()
					},
				}}
				position={position}
				icon={icon()}
			>
				<Tooltip className={'project-name1'} permanent={true} offset={[0, 0]} direction={'top'}>
					<CustomToolTip
						id={`tooltip-${projectId}`}
						markerElem={markerElem}
						open={open}
						onClose={handleClose}
						anchorEl={anchorEl}
						handleClickMarker={handleClick}
					/>
				</Tooltip>
			</Marker>
		</>
	)
}
